<template>

    <Dialog :dialog="dialog" :dialog-width="dialogWidth" @close="closeFaqModal">
        <template #title>
            {{ id > 0 ? "Edit FAQ Item" : "Add New FAQ Item" }}
        </template>
        <template #body>
            <v-form ref="faqItemForm" v-model="faqModalFormValid">
                <v-row class="mb-3">
                    <v-col cols="12">
                        <label class="font-size-16 font-weight-500 mb-2 d-block">Question *</label>
                        <TextField v-model="faqModalData.question" label="Question" :rules="[
                            validateRules.required(faqModalData.question, 'Question'),
                        ]" placeholder="Enter your question" dense filled solo flat class="pt-0 mt-3" />
                    </v-col>
                </v-row>

                <v-row class="mb-3">
                    <v-col cols="12">
                        <label class="font-size-16 font-weight-500 mb-2 d-block">Answer *</label>
                        <editor v-model="faqModalData.answer" :disabled="disabled" />
                    </v-col>
                </v-row>
            </v-form>
        </template>
        <template #action>
            <v-btn color="grey darken-1" text @click="closeFaqModal">
                Cancel
            </v-btn>
            <v-btn color="primary" @click="saveFaqModal" :loading="modalSaving"
                :disabled="!faqModalFormValid || modalSaving">
                {{ id > 0 ? "Update" : "Add" }} FAQ
            </v-btn>
        </template>
    </Dialog>
</template>

<script>
import Editor from "@/view/pages/partials/TinyMCE.vue";
import Dialog from "@/view/components/Dialog.vue";
import validationMixin from "@/core/plugins/validation-mixin";
import { POST, PUT } from "@/core/services/store/request.module";

export default {
    name: "FAQ",
    components: {
        Editor,
        Dialog,
    },
    mixins: [validationMixin],
    props: {
        dialog: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            default: 'common',
        },
        id: {
            type: Number,
            default: 0,
        },
        typeId: {
            type: Number,
            default: 0,
        },
        data: {
            type: Object,
            default: () => {
                return new Object();
            },
        },
    },
    watch: {
        id: {
            deep: true,
            immediate: true,
            handler(param) {
                if (param > 0) {
                    this.faqModalData = this.data;
                }
            },
        },
    },
    data() {
        return {
            formValid: false,
            loading: false,
            disabled: false,
            faqItems: [],
            faqModalFormValid: false,
            modalSaving: false,
            isEditMode: false,
            editingIndex: null,
            faqModalData: {
                question: "",
                answer: "",
                status: true,
            },

            itemSaveTimeouts: {},
        };
    },

    computed: {
        dialogWidth() {
            return this.lodash.toSafeInteger((document.body.clientWidth / 100) * 50);
        },
    },

    methods: {
        // Emit success/error messages to parent component
        emitSuccess(message) {
            this.$emit('show-success', message);
        },

        emitError(message) {
            this.$emit('show-error', message);
        },

        closeFaqModal() {
            this.faqModalData = {
                question: "",
                answer: "",
                status: true,
            };
            this.$emit('close-dialog', false);
        },

        saveFaqModal() {
            if (!this.$refs.faqItemForm.validate()) return;

            const question = this.faqModalData.question.trim();
            const answer = (this.faqModalData.answer).trim();

            if (!question || !answer) {
                this.emitError("Both question and answer are required");
                return;
            }

            this.modalSaving = true;

            const itemData = {
                question,
                answer,
                type: this.type,
                type_id: this.typeId,
                status: this.faqModalData.status,
            };

            const isEdit = this.id > 0;
            const url = isEdit ? `web-setup/faq-items/${this.id}` : "web-setup/faq-items";
            const method = isEdit ? PUT : POST;

            this.$store
                .dispatch(method, { url, data: itemData })
                .then(() => {
                    this.resetFaqModal();
                    this.$emit("success", true);
                })
                .catch(() => {
                    this.$emit("error", true);
                })
                .finally(() => {
                    this.modalSaving = false;
                });
        },

        resetFaqModal() {
            this.faqModalData = {
                question: "",
                answer: "",
                status: true,
            };
        }
    },

    beforeDestroy() {
        Object.values(this.itemSaveTimeouts).forEach((timeout) => {
            clearTimeout(timeout);
        });
    },
};
</script>